var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PatrimoniosList',{attrs:{"idEvento":_vm.idEvento,"patrimonios":_vm.patrimonios}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }